import React from 'react';
import Layout from '../components/Layout';

const Donasi = () => {

  return (
    <Layout>
      <section>
        <div className='flex flex-col gap-1 justify-center items-center p-4 text-white'>
          <h2 className='text-2xl lg:text-3xl font-bold text-yellow-400'>Donasi</h2>
          <h1 className='text-3xl lg:text-4xl text-cyan-600'>Rumah Tahfidz An-Nuur</h1>
        </div>
        <div className='flex flex-col gap-3 px-5 md:px-20 lg:px-48 font-inter text-white'>
          <p className='text-center lg:text-xl'>Berbagi Kebaikan, Berinvestasi Akhirat Bersama Rumah Tahfidz</p>
          <div className='flex flex-col gap-3 lg:text-xl'>
            <p>Rumah Tahfidz adalah tempat suci di mana anak-anak kita menanam ilmu yang akan menjadi cahaya bagi hidup mereka. Melalui hafalan Al-Qur'an, mereka membentuk karakter, menumbuhkan cinta kepada Allah, dan menyiapkan diri menjadi generasi Qur'ani.</p>
            <p>Mari kita bersama-sama mendukung perjuangan mereka. Dengan berdonasi, Anda bukan hanya membantu pembangunan fasilitas yang layak, tetapi juga berkontribusi pada pendidikan para calon penghafal Al-Qur'an yang insyaAllah akan membawa keberkahan bagi umat.</p>
            <p>Allah SWT berfirman:</p>
            <p className='px-4 lg:px-20 bg-transparent font-semibold'>"Perumpamaan (nafkah yang dikeluarkan oleh) orang-orang yang menafkahkan hartanya di jalan Allah adalah serupa dengan sebutir biji yang menumbuhkan tujuh tangkai; pada tiap-tiap tangkai itu terdapat seratus biji. Allah melipatgandakan (ganjaran) bagi siapa yang Dia kehendaki. Dan Allah Maha Luas (karunia-Nya) lagi Maha Mengetahui."
            (Surah Al-Baqarah: 261)</p>
            <p>Setiap rupiah yang Anda keluarkan adalah investasi amal jariyah yang pahalanya akan terus mengalir, bahkan setelah kita tiada.</p>
            <p>Yuk, Berbagi Kebaikan Sekarang!<br></br>Klik tautan di bawah ini untuk berdonasi dan jadilah bagian dari gerakan membangun generasi penghafal Al-Qur'an.</p>
          </div>
        </div>
      </section>

      <section>
        <div className="px-4 my-8" id="containerRef">
          <div className="max-w-md lg:max-w-2xl mx-auto bg-yellow-300 px-6 sm:px-12 py-8 rounded-3xl flex justify-center flex-col shadow-2xl shadow-gray-700" data-aos="fade-up">
            <span className="text-center text-sm sm:text-base lg:text-lg">Rekening Donasi</span>
            <h1 className="text-base sm:text-lg lg:text-xl font-inter font-bold text-center">
              Rumah Tahfidz An-Nuur
            </h1>
            <div className="flex justify-center">
              <hr className="bg-white mb-2 h-1 w-1/2 mx-auto" />
            </div>
            <div className='px-8'>
              <img src="qr.png" alt="" className="rounded-md w-full sm:w-2/4 lg:w-1/2 mx-auto" />
            </div>
            <p className='text-center text-sm'>*QR masih belum bisa untuk digunakan, hubungi kontak dibawah jika ingin berdonasi</p>
            <div className="flex justify-center mt-4">
              <img src="logo.webp" alt="" className="h-16 sm:h-20 lg:h-24" />
            </div>
            <p className="text-center text-sm sm:text-base lg:text-lg mt-2">
              7133 1480 88 an. Yayasan Rumah Tahfidz An-Nuur
            </p>
            <p className="mt-4 text-center font-bold text-sm sm:text-base lg:text-lg">
              Konfirmasi Donasi:
            </p>
            <p className="text-center text-sm sm:text-base lg:text-lg"><a href='https://wa.me/6281233487147'>(+62) 812-3348-7147</a></p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Donasi;